import Image from "next/image";
import { isSvg, type MaybeMedia } from "@/lib/media";

type Props = {
  media: MaybeMedia;
  className?: string;
  alt?: string;
  sizes?: string;
  preload?: boolean;
};

/**
 * The port of wp_get_attachment_image(): an <img> for an attachment, with the
 * attachment's own alt unless one is passed. SVGs skip the optimiser, which
 * would refuse them.
 */
export default function WpImage({
  media,
  className,
  alt,
  sizes = "100vw",
  preload,
}: Props) {
  if (!media) {
    return null;
  }

  const altText = alt ?? media.alt;

  if (isSvg(media) || !media.width || !media.height) {
    // eslint-disable-next-line @next/next/no-img-element
    return (
      <img
        src={media.src}
        className={className}
        alt={altText}
        loading={preload ? "eager" : "lazy"}
        decoding="async"
      />
    );
  }

  return (
    <Image
      src={media.src}
      width={media.width}
      height={media.height}
      className={className}
      alt={altText}
      sizes={sizes}
      preload={preload}
    />
  );
}
